export default __webpack_public_path__ + "static/media/feeling_5_mobile_view.7b64bb53.svg";